const columns = 7;

const slipCells = horseSize => {
  const cells = [];
  for (let row = 0; row < horseSize + 2; row++) {
    const rowData = [];
    for (let col = 0; col < columns; col++) {
      const cell = {
        rowNo: row,
        colNo: col,
        isLegNumber: row === 0,
        isAllSelectButton: row === 1
      };
      rowData.push(cell);
    }
    cells.push(rowData);
  }
  return cells;
};


export { slipCells };

